import React from "react"
import styled from "styled-components"
import ContainerMax from "components/shared/ContainerMax"
import ContentWrap from "components/shared/ContentWrap"

const Title = styled.h1`
    padding: calc(80px + 3rem) 0 4rem 0;
    margin: 0;
`

const PageTitle = ({title}) => {
    return(
        <ContainerMax>
            <ContentWrap>
                <Title dangerouslySetInnerHTML={{ __html: title}} />
            </ContentWrap>
        </ContainerMax>
    )
}

export default PageTitle